import { nextTick } from 'vue';
import { useSessionStore } from '@/stores/SessionStore.ts';

export default class SignOutService {
  /**
   * Sign out by revoking the session.
   *
   * @returns {Promise<boolean>} True if the session is no longer valid.
   */
  async signOut(): Promise<boolean> {
    useSessionStore().setSigningOut(true);
    await nextTick();
    useSessionStore().revoke();

    return !useSessionStore().isValid();
  }
}
